import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components/index";
import API from "@beardeddevops/react.api";
import Objects from "../Objects";
import UserRoles from "constants/UserRoles";
import Select from "react-select";

export default class Copyables extends Framework.Components.Collection {

	constructor(props) {
		let model = new API.BuildClass(Types.Copyables._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.data = [];
		this.state.selectedRegions = [];
		this.state.regions = [];
	}

	async componentDidMount() {
		await this.getCopyables();
		await this.getRegions();
	}

	getCopyables = async () => {
		let model = new API.BuildClass(Types.Copyables._name, API.RequestType.READ);
		this.read = 'GET_COLLECTION';
		model.filter = {
			'filterRegions': this.state.selectedRegions.map((region) => {return region.value})
		}
		this.data = await model.submit(null, this.read);
		this.setState({
			data: this.data
		});
	}

	handleRegions = async (value) => {
		if (value) {
			let regions = [];
			for (let i = 0; i < value.length; i++) {
				regions.splice(0, 0, value[i]);
			}
			this.state.selectedRegions = regions;
		} else {
			this.state.selectedRegions = [];
		}
		await this.getCopyables();
	}

	getRegions = async () => {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		model.limit = 5000;
		try {
			this.regions = await model.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				return a.name.localeCompare(b.name)
			})
			this.setState({
				regions: this.regions
			});
		} catch (error) {
		}
		return this.state.regions;
	}


	render() {
		return (
			<fieldset>
				<div className={'row py-2'}>
					<div className={'col-4'} style={{zIndex: 999}}>
						{/*<Select*/}
						{/*	key={this.state.regions}*/}
						{/*	placeholder={"Region Select"}*/}
						{/*	isMulti*/}
						{/*	isClearable*/}
						{/*	value={this.state.selectedRegions.map(region => {*/}
						{/*		return (*/}
						{/*			{value: region.value, label: region.label})*/}
						{/*	})}*/}
						{/*	onChange={this.handleRegions}*/}
						{/*	options={this.state.regions.map(region => {*/}
						{/*		return (*/}
						{/*			{value: region.pkey, label: region.name})*/}
						{/*	})}*/}
						{/*/>*/}
					</div>
				</div>
				{this.state.data.length > 0 ? this.state.data.map((region, index) => {
					return region.pkey === 'generic' ? (
						<div className={'form-group'}>
							<h4 className={'section-title'}>
								Generic Copyables
							</h4>
							<div className={'row'} key={'region-' + index}>
								{region.copyables.map((copyable, index) => {
									return (
										<div className={'col-lg-4 col-sm-12'}>
											<Objects.Copyable
												id={copyable}
												isNew={false}
												editable={this.props.roles.includes(UserRoles.Admin)}
												userRoles={this.props.userRoles}
												afterDelete={this.refreshPage}
											/>
										</div>
									)
								})}
							</div>
						</div>
					) : (
						<>
							{region.copyables.length > 0 &&
									<div className={'form-group'}>
										<h4 className={'section-title'}>
											{region.name} - Generic Copyables
										</h4>
										<div className={'row'} key={'region-' + index}>
											{region.copyables.map((copyable, index) => {
												return (
													<div className={'col-lg-4 col-sm-12'}>
														<Objects.Copyable
															id={copyable}
															isNew={false}
															editable={this.props.roles.includes(UserRoles.Admin)}
															userRoles={this.props.userRoles}
															afterDelete={this.refreshPage}
														/>
													</div>
												)
											})}
										</div>
									</div>

							}
							{region.subregions?.map((subregion, index) => {
								return (
									<div className={'form-group'}>
										<h4 className={'section-title'}>
											{region.name} - {subregion.name} Copyables
										</h4>
										<div className={'row'} key={'region-' + index}>
											{subregion.copyables.map((copyable, index) => {
												return (
													<div className={'col-lg-4 col-sm-12'}>
														<Objects.Copyable
															id={copyable}
															isNew={false}
															editable={this.props.roles.includes(UserRoles.Admin)}
															userRoles={this.props.userRoles}
															afterDelete={this.refreshPage}
														/>
													</div>
												)
											})}
										</div>
									</div>
								)
							})}
						</>
					)
				}) : null}
			</fieldset>
		)
	}

}
